export const getUrlGameVideo = (gameId: string) => {
  if (!gameId) return "";
  return `${process.env.REACT_APP_ASSETS_ENDPOINT}assets/onboarding/games/${gameId}/gameplay.mp4`;
};
